import template from './delegatedRequestModal.html';
import controller from './delegatedRequestModal.controller';
import './delegatedRequestModal.scss';

let delegatedRequestModalComponent = {
  restrict: 'E',
  bindings: {
    employeeToEdit: '<',
    updateEmployee: '&',
    isMobileApp: '<',
  },
  template,
  controller,
};

export default delegatedRequestModalComponent;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/delegatedRequestModal/delegatedRequestModal.component.js